import { render, staticRenderFns } from "./vehicleApply.vue?vue&type=template&id=68f4d465&"
import script from "./vehicleApply.vue?vue&type=script&lang=js&"
export * from "./vehicleApply.vue?vue&type=script&lang=js&"
import style0 from "./vehicleApply.vue?vue&type=style&index=0&id=68f4d465&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports